import { render } from "./uiAsideMenuItem.vue?vue&type=template&id=3cf51691&scoped=true"
import script from "./uiAsideMenuItem.vue?vue&type=script&lang=js"
export * from "./uiAsideMenuItem.vue?vue&type=script&lang=js"

import "./uiAsideMenuItem.vue?vue&type=style&index=0&id=3cf51691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf51691"]])

export default __exports__